import api from '@/services/api'
import endpoints from '@/services/endpoints'
import {
  CheckResetLinkResponse,
  ConfirmPasswordResetPayload,
  LoginPayload,
  LoginResponse,
  PasswordResetPayload,
  PasswordResetResponse,
  User,
} from '@/types/auth'

const login = async (payload: LoginPayload): Promise<LoginResponse> => {
  const response = await api.post(endpoints.AUTH.LOGIN, payload)
  return response.data
}

const getUserMe = async (): Promise<User> => {
  const response = await api.get(endpoints.AUTH.MYINFO)
  return response.data
}

const resetPassword = async (payload: PasswordResetPayload): Promise<PasswordResetResponse> => {
  const response = await api.post(endpoints.AUTH.PASSWORD_RESET, payload)
  return response.data
}

const confirmResetPath = (uid: string, token: string) =>
  endpoints.AUTH.PASSWORD_RESET_CONFIRM.replace(':uid', uid).replace(':token', token)

const checkPasswordResetLink = async (uid: string, token: string): Promise<CheckResetLinkResponse> => {
  const response = await api.get(confirmResetPath(uid, token))
  return response.data
}

const confirmPasswordReset = async (uid: string, token: string, payload: ConfirmPasswordResetPayload) => {
  const response = await api.post(confirmResetPath(uid, token), payload)
  return response.data
}

export default {
  login,
  getUserMe,
  resetPassword,
  checkPasswordResetLink,
  confirmPasswordReset,
}
